
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
       
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        let addons = this.querySelector('[name="addons_ids"]');
        let id = this.querySelector('[name="id"]');
        let quantity = this.querySelector('[name="quantity"]');
        let sellingPlan = this.querySelector('[name="selling_plan"]');
        let vformData = { items: [] };

        const response = await fetch('/cart.js');
        const cart = await response.json();

        let isProductAlreadyAdded = cart.items.some(i => i.id == id.value)
      
        vformData.items.push({
          id: id.value,
          selling_plan: sellingPlan ? sellingPlan.value : null,
          quantity: quantity ? quantity.value : 1
        });
        if (addons && addons.value && !isProductAlreadyAdded) {
          let addons_ids = addons.value.split(',');
          for (let i in addons_ids) {
            vformData.items.push({
              id: addons_ids[i],
              quantity: quantity ? quantity.value : 1,
              properties: { 'free_with': id.value }
            });
          }
          vformData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          config.body = JSON.stringify(vformData);
          config.headers['Content-Type'] = 'application/json';
          window.vformData = vformData;
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(async () => {
                    await this.cart.renderContents(response);
                    await this.checkAndAddFreeGift();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if(window?.freeEssentialGreensStarterPack){
                await window.freeEssentialGreensStarterPack(false) 
              }
              if(window.redirectToCheckout){
                window.location.href = '/checkout';
                return;
              }
              await this.cart.renderContents(response);
              await this.checkAndAddFreeGift();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

        const closeButton = document.querySelector('.quick-view-popup .close-button');
        if (closeButton) {
          setTimeout(() => {
            closeButton.click();
          }, 2000);
        }
      }

      async addFreeGiftToCart(freeGiftId) {
        const data = {
          items: [{
            id: freeGiftId,
            quantity: 1,
            properties: {
              '_free_gift': true
            }
          }],
          'sections':  this.cart.getSectionsToRender().map((section) => section.id)
        };
      
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
          const result = await response.json();
          if (this.cart) {
            await this.cart.renderContents(result);
          }
          return result;
        } catch (error) {
          console.error("Error adding free gift:", error);
          return null;
        }
      }
      
      async checkAndAddFreeGift() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const cartTotal = cart.total_price / 100;
          const inputElement = document.querySelector('input[name="freegift_id"]');
          if (!inputElement) return;
          const moneyLimit = parseFloat(inputElement.getAttribute('data-money-limit'));
          const freeGiftId = inputElement.value;
          
          // Check if free gift is already in cart
          const freeGiftInCart = cart.items.some(item => 
            item.properties && item.properties._free_gift === true
          );
          
          if (cartTotal >= moneyLimit && !freeGiftInCart) {
            await this.addFreeGiftToCart(freeGiftId);
          } else if (cartTotal < moneyLimit && freeGiftInCart) {
            // Remove free gift if cart total drops below threshold
          }
        } catch (error) {
          console.error("Error checking/adding free gift:", error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
